import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HousingDetailItem from './HousingDetailItem';
import { housingFundsDetailInputList1 } from '../../../../common/data';

import DetailButtonSection from '../../../../components/DetailButtonSection';
import DetailTitleSection from '../../../../components/DetailTitleSection';
import { getHousingFundsDataDetail, resetDetailData, saveHousingFunds } from '../housingFundsSlice';
import {
  getAlertMessageFunction,
  handleNumberChange2,
  magamCertifyCheck,
} from '../../../../common/Util';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import { setIsDataModified } from '../../../common/commonSlice';

//주택 임차 차입금
const Type1 = ({ onClose, isOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('deductions/housingFunds');
  const { t: tCommon } = useTranslation('common');
  const { isMagam, isCertify } = useSelector(state => state.common);
  const inputList = housingFundsDetailInputList1(t);

  const { detailData } = useSelector(state => state.housingFunds);
  const [dataList, setDataList] = useState({
    htm085: '',
    htm086: '',
    htm078: '',
    htm117: '',
  });

  useEffect(() => {
    if (isOpen) {
      dispatch(getHousingFundsDataDetail({ hInType: '1' }));
    }

    return () => {
      dispatch(resetDetailData());
    };
  }, [dispatch, isOpen]);

  useEffect(() => {
    if (detailData) {
      setDataList(detailData);
    }
  }, [detailData]);

  const handleChange = e => {
    let { name, value } = e.target;

    value = handleNumberChange2(value);

    dispatch(setIsDataModified(true));
    setDataList({ ...dataList, [name]: value });
  };

  const handleSave = async () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }
    const alertMessage = getAlertMessageFunction();
    let data = {
      hInType: '1',
      htm078: dataList?.htm078 || '0',
      htm085: dataList?.htm085 || '0',
      htm086: dataList?.htm086 || '0',
      htm117: dataList?.htm117 || '0',
    };

    console.log('data >>', data);
    //원리금상환액 이자를 입력~
    if (data.htm078 != 0 && data.htm117 == 0) {
      alertMessage(t('detail.alertMessage'), 'error');
      return;
    }

    try {
      const response = await dispatch(saveHousingFunds(data)).unwrap();
      if (response.resultCode === 'OK') {
        alertMessage(tCommon('alertMessage.saveSuccess'), 'success');
        onClose();
      } else {
        alertMessage(tCommon('alertMessage.saveFail'), 'error');
      }
    } catch (error) {
      console.log(error);
      alertMessage(tCommon('alertMessage.saveFail'), 'error');
    }
  };

  return (
    <SlideRightDialog onClose={onClose} isOpen={isOpen}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <DetailTitleSection title={t('detail.title1')} />
        <HousingDetailItem {...{ inputList, dataList, setDataList, handleChange }} />
        <DetailButtonSection onSave={handleSave} onClose={onClose} />
      </div>
    </SlideRightDialog>
  );
};

export default Type1;
